<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :options="[{ type: 'alert' }]" />

    <table-custom
      :board="board"
      :is-print="isPrint"
      :controls="true"
      title="근로자 정보"
      :tableData="[
        { id: 'input1', title: 'No.', type: 'no', placeholder: '입력', width: '50px' },
        { id: 'input2', title: '부서명', type: 'company', },
        { id: 'input3', title: '근로자정보', type: 'text', placeholder: '입력' },
      ]"
      v-model="form.tableList"
      @company-select="companySelect"
    />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FieldWorkplaceTableEmployee from "@/components/FieldWorkplaceTableEmployee.vue";

export default {
  components: {
    FieldWorkplaceTableEmployee,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
    'form.tableList': {
      immediate: true,
      deep: true,
      handler(value) {
        const companys = [...new Set(value.map(item => item.com_name))];
        this.form.field_names = companys.join(',');

      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        tableList: [],
        field_names: "",
        field_array: [],
      },
    };
  },
  methods: {
    companySelect(index, value) {
      this.form.tableList[index].com_name = value.com_name;
    },
  },
};
</script>

<style scoped lang="scss"></style>
